import { c as _c } from "react/compiler-runtime";
import { Heading, LayoutContainer, Picture } from '@petsmart-ui/sparky';
import cn from 'classnames';
import { propsImageItems } from '../../utils/propsImagesItems';
import type { CampaignBannerSmProps } from './types';
import './CampaignBannerSm.scss';
export function CampaignBannerSm(t0) {
  const $ = _c(21);
  const {
    header,
    image,
    textColor,
    backgroundColor
  } = t0;
  let t1;
  if ($[0] !== image) {
    t1 = image && propsImageItems(image);
    $[0] = image;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const img = t1;
  const t2 = textColor === "White";
  let t3;
  if ($[2] !== t2) {
    t3 = cn("campaign-banner-sm", {
      "campaign-banner-sm__white": t2
    });
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== backgroundColor || $[5] !== image) {
    t4 = !image && {
      backgroundColor
    };
    $[4] = backgroundColor;
    $[5] = image;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = {
      ...t4
    };
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== image || $[10] !== img) {
    t6 = img && <Picture imgAlt={image.webAltText} imgSrc={img[0]?.srcSet} items={img} />;
    $[9] = image;
    $[10] = img;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== header) {
    t7 = <Heading tagName="h2">{header}</Heading>;
    $[12] = header;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t6 || $[16] !== t7) {
    t8 = <div className="campaign-banner-sm__content" style={t5}>{t6}{t7}</div>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t3 || $[19] !== t8) {
    t9 = <LayoutContainer data-testid="campaign-banner-sm" className={t3}>{t8}</LayoutContainer>;
    $[18] = t3;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}